<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div class="promocode text-center">
      <h3 class="mb-8">
        {{ title }}
      </h3>
      <p class="mb-0">
        {{ msg }}
      </p>
      <VeeForm @submit="validate">
        <VeeField
          id="promo-code"
          v-model="promoCode"
          name="promoCode"
          data-nw="promo-code-input"
          class="form-control ff-m promocode__input"
        >
        </VeeField>

        <BaseButton
          :disabled="!promoCode || validatingCode"
          :class="{ loading: validatingCode }"
          class="promocode__cta fw-semibold"
          type="submit"
          data-nw="promo-code-btn"
          variant="call-to-action"
          size="lg"
        >
          {{ $label('redeem.collectBtn') }}
        </BaseButton>
      </VeeForm>
    </div>
    <p
      class="text-small text-center fst-italic mt-16 mb-0"
      v-html="$label('redeem.promoCodeProblem')"
    ></p>
  </div>
</template>

<script>
import PromoCodeMixin from '~/mixins/promocode'

export default {
  mixins: [PromoCodeMixin],
  props: {
    msg: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    onPromoCodeVerification: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      promoCode: '',
    }
  },
  computed: {
    supportEmail() {
      const labelKey = 'common.supportEmail'
      const email = this.$label(labelKey)

      return email === labelKey ? '' : `mailto:${email}`
    },
  },
  created() {
    if (typeof this.$route.query.promocode !== 'undefined') {
      this.promoCode = this.$route.query.promocode
    }
  },
  methods: {
    async validate() {
      this.validatingCode = true
      try {
        await this.validatePromoCode(this.promoCode)
        this.onPromoCodeVerification()
      } catch (error) {
        this.onValidationError(error, this.promoCode)
      } finally {
        this.validatingCode = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.promocode {
  background-color: $grey-01;
  padding: 40px 24px;
}

.promocode {
  &__input {
    max-width: 348px;
    margin: 16px auto 24px auto;
  }
}

@include media-breakpoint-up(lg) {
  .promocode {
    padding: 40px 24px 48px;
  }

  .promocode__input {
    margin: 32px auto;
  }
}
</style>
